'use client'

import React, {useEffect, useRef, useState} from "react";

import {
    Button,
    Box,
    Container,
    Flex,
    Heading,
    Image,
    Stack,
    Text,
    VStack,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    Input,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    FormControl,
    FormLabel,
    FormHelperText,
    Checkbox,
    CheckboxGroup,
    Radio,
    RadioGroup,
    chakra,
    useToast, Link, SimpleGrid
} from "@chakra-ui/react";

import {
    Table,
    Thead,
    Tbody,
    Tfoot,
    Tr,
    Th,
    Td,
    TableCaption,
    TableContainer,
} from '@chakra-ui/react';
import { Tabs, TabList, TabPanels, Tab, TabPanel,  Divider,       List,    ListIcon,    ListItem, useColorModeValue, } from '@chakra-ui/react';

import {Header as Nav} from "../header/Header";
import {Footer} from "../footer/Footer";
import {FormControlEvo} from "../forms/chakra/FormControlEvo";
import {fieldNameAndLabels, emptyFormData, PAYMENT_CARD, PAYMENT_BANK_TRANSFER, PAYMENT_CODE, PRICE_ONLINE_PHYSICAL_COPY, PARAM_ORDER, DPH_VALUE, addHashOrderPairsToCookies, swapDotForComma} from "../../infrastructure/utils/formUtils";

import {Form, redirect, useNavigate} from "react-router-dom";

import { FaCheckCircle } from 'react-icons/fa';
import {EmailInputEvo} from "../forms/chakra/inputs/EmailInputEvo";
import {useEvoContext} from "../../context/evo.context";

import '../../styles/chakra-ui-styles.css';
import PublicIssuesDataProvider from "../dataProviderEvo/public-issues-data-provider";
import SubscriptionCodeValidateDataProvider from "../dataProviderEvo/subscription-code-validate-data-provider";
import Cookies from "js-cookie";
import PurchaseDataProvider from "../dataProviderEvo/purchase-data-provider";
import IssuesDataProvider from "../dataProviderEvo/issues-data-provider";
import PaymentOptionsDataProvider from "../dataProviderEvo/payment-options-data-provider";
import SubscriptionOptionsDataProvider from "../dataProviderEvo/subscription-options-data-provider";
import {ReadIssueWithImageLink} from "../links/ReadIssueWithImageLink";
import {FormLabelEvo} from "../forms/chakra/label/FormLabelEvo"; // Import your custom CSS
import {ScreenContainer} from "../container/ScreenContainer";
import formValidator from '../forms/validate/validate';
import {
    ROUTE_MAIN,
    ROUTE_PARAM_ORDER,
    ROUTE_PASSWORD_CHANGE,
    ROUTE_PASSWORD_RESET,
    ROUTE_PURCHASE_CONFIRMATION, ROUTE_PURCHASE_CONFIRMATION_PART
} from "../../App";
import UserEmailCheckDataProvider from "../dataProviderEvo/user-email-check-data-provider";
import getFormValues from "../forms/values/formValues";



export default function Purchase() {
    return (
        <Box bg={useColorModeValue('#f9f9f9', '#1a202c')}>
            <Nav/>
            <ScreenContainer>
                <Stack direction={{base: 'column', md: 'column'}}>
                    <Flex flex={1} align={'center'} justify={'center'}>
                        <Stack spacing={6} w={'full'}>
                            <chakra.h1 textAlign={'center'} fontSize={'4xl'} py={10} fontWeight={'bold'}>
                                Předplaťte si Vinařský obzor
                            </chakra.h1>
                        </Stack>
                    </Flex>

                </Stack>
                <Box>
                    <PurchaseForm/>
                </Box>
            </ScreenContainer>
            <Footer/>
        </Box>
    )
}

function PurchaseForm({}) {

    const navigate = useNavigate();
    const {isLoggedIn, userData, authToken, userId} = useEvoContext();
    const toast = useToast();

    const [tabIndex, setTabIndex] = useState(0);
    const [formData, setFormData] = useState(emptyFormData);

    let fieldNamesAndLabels = fieldNameAndLabels;

    formData.subscriptionType = '3';

    useEffect(() => {

        const keys = Object.keys(userData); // ['id', 'name', 'email', 'age', 'isActive', 'address']
        const values = Object.values(userData);

        if(keys.length > 0){

            {keys.map((value, index) => (
                setFormData((prevData) => ({
                    ...prevData,
                    [keys[index]]: values[index],
                }))
            ))}
        } else {
            setFormData(emptyFormData);
        }



    }, [userData]);


    const [errors, setErrors] = useState({});

    const validateForm = () => {

        const form = formRef.current;
        if (form) {

            const currentFormData = getFormValues(form);

            const additionalRules = {
                password: {
                    customDisabled: true
                },
            };

            currentFormData.paymentType = formData.paymentType;
            currentFormData.subscriptionType = formData.subscriptionType;

            const {isValid, validationErrors} = formValidator(currentFormData, fieldNamesAndLabels, additionalRules);
            setErrors(validationErrors);

            if (isValid) {

                /*if( formData.paymentType == PAYMENT_CODE){
                    let dp = new SubscriptionCodeValidateDataProvider();
                    return dp.getData(formData.subscriptionActivationCode, {}).then((res) => {

                        if (res.status === 'ERROR') {

                            toast({
                                // title: 'Placeni se nezdařilo',
                                description: res.errors[0],
                                status: 'error',
                                duration: 5000,
                                isClosable: true,
                            });

                            return false;
                        } else if (res.status === 'OK') {
                            console.log('OK')
                            return true;
                        }

                    });
                } else {
                    return true;
                }*/

                return true;
            }
        }
        return false;
    };



    const formRef = useRef(null);

    const [isAddressDeliveryVisible, setIsAddressDeliveryVisible] = useState(false);
    const [isCompanyFieldsVisible, setIsCompanyFieldsVisible] = useState(false);
    const [isCodeInputVisible, setIsCodeInputVisible] = useState(false);

    // Handle form input changes
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {

        const { name, value } = e.target;

        let fieldValue = value;

        if(fieldNameAndLabels.deliveryDifferentAddress.name === name){
            fieldValue = e.target.checked;
            setIsAddressDeliveryVisible(fieldValue)
        }

        if(fieldNameAndLabels.asCompany.name === name){
            fieldValue = e.target.checked;
            setIsCompanyFieldsVisible(fieldValue)
        }

        setFormData((prevData) => ({
            ...prevData,
            [name]: fieldValue,
        }));
    };

    const handleRadioPaymentChange = (value) => {

        if(value == PAYMENT_CODE) {
            setIsCodeInputVisible(true);
        } else {
            setIsCodeInputVisible(false);
        }

        setFormData((prevData) => ({
            ...prevData,
            paymentType: value,
        }));
    };

    const handleRadioPriceChange = (value) => {
        setFormData((prevData) => ({
            ...prevData,
            subscriptionType: value,
        }));
    };

    const timeoutRef = useRef(null);

    const [showPassword, setShowPassword] = useState(false);

    const handleChangeEmail = (e) => {
        const { name, value } = e.target;

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {

            if(value && (!isLoggedIn || (isLoggedIn && value != userData.email))) {

                toast.closeAll();

                let dp = new UserEmailCheckDataProvider();
                dp.getData(value, {}).then((res) => {

                    if (res && res.status === 'OK') {
                        setShowPassword(false);
                    } else {
                        setShowPassword(true);
                        toast({
                            title: 'Upozornění ',
                            description: res.errors[0],
                            status: 'info',
                            duration: 5000,
                            isClosable: true,
                            position: "top"
                        });

                    }
                });
            } else {
                setShowPassword(false);
            }

        }, 700);

        handleChange(e);
    };


    // // Handle form submission
    // const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    //     e.preventDefault(); // Prevent default form submission
    //
    //     console.log("e is " + e);
    //
    //     if (validateForm()) {
    //
    //         console.log("validated");
    //
    //         let dp = new PurchaseDataProvider();
    //         dp.sendData(formData, formData).then((res) => {
    //
    //             console.log("called");
    //
    //             console.log(res);
    //             if (res && res.status === 'OK') {
    //                 console.log("ok");
    //
    //                 let basketHash = res.data.basket.hash,
    //                     orderId = res.data.basket.order_number;
    //
    //                 addHashOrderPairsToCookies(basketHash, orderId);
    //
    //                 if(res.data.basket.payment_method.code === PAYMENT_CARD){
    //                     window.location.href = res.data.basket.payment_gateway_payment.redirect_url;
    //                 } else /*if(res.data.basket.payment_method.code === PAYMENT_BANK_TRANSFER)*/ {
    //                     navigate(ROUTE_MAIN + ROUTE_PURCHASE_CONFIRMATION + '?' + ROUTE_PARAM_ORDER + '=' + res.data.basket.hash);
    //                 }
    //             } else {
    //
    //                 console.log(res);
    //
    //                 console.log("error");
    //
    //             //     toast({
    //             //         // title: 'Placeni se nezdařilo',
    //             //         description: res.errors[0],
    //             //         status: 'error',
    //             //         duration: 5000,
    //             //         isClosable: true,
    //             // });
    //             }
    //
    //         });
    //     }
    // };

    const errorText = "Při pokusu o dokončení objednávky nastala chyba. Prosíme, zkuste objednávku odeslat znovu.";

    // Handle form submission
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault(); // Prevent default form submission

        if (validateForm()) {
            try {
                let headers = {};

                if(isLoggedIn){
                    headers = {
                        'Auth-token': authToken,
                        'id_user': userId
                    }
                } else if(showPassword){

                    headers = {
                        "Auth-login-name": formData.email,
                        "Auth-login-password-b64": btoa(formData.password)
                    }
                }

                let params = formData;
                delete params.password;

                const dp = new PurchaseDataProvider();
                const res = await dp.sendData(params, headers);

                if (res && res.status === 'OK') {

                    const basket = res.data?.basket;
                    if (!basket) {
                        toast({
                            description: res?.errors?.[0] || errorText,
                            status: 'error',
                            duration: 5000,
                            isClosable: true,
                            position: "top"
                        });
                    }

                    const { hash: basketHash, order_number: orderId } = basket;

                    addHashOrderPairsToCookies(basketHash, orderId);

                    if (basket.payment_method?.code === PAYMENT_CARD) {
                        const redirectUrl = basket.payment_gateway_payment?.redirect_url;
                        if (!redirectUrl) {
                            toast({
                                description: res?.errors?.[0] || errorText,
                                status: 'error',
                                duration: 5000,
                                isClosable: true,
                                position: "top"
                            });
                        }
                        window.location.href = redirectUrl;
                    } else {
                        navigate(
                            `${ROUTE_MAIN}${ROUTE_PURCHASE_CONFIRMATION_PART}${basketHash}`
                        );
                    }
                } else {
                    toast({
                        description: res?.errors?.[0] || errorText,
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                        position: "top"
                    });
                }
            } catch (error) {
                toast({
                    description: errorText,
                    status: 'error',
                    duration: 5000,
                    isClosable: true,
                    position: "top"
                });
            }
        }
    };

    // const [paymentOptions, setPaymentOptions] = useState<{ [key: string]: any }>({});
    const [paymentOptions, setPaymentOptions] = useState({});

    if( Object.keys(paymentOptions).length  == 0) {
        let dp = new PaymentOptionsDataProvider();
        dp.getData({}, {}).then((res) => {
            if (res && res.status === 'OK') {
                setPaymentOptions(res.data.values);
            } /*else {
                toast({
                    title: 'Kódem pro aktivaci předplatného',
                    description: res.errors[0] || 'Zkuste akci zopakovat.',
                    status: 'error',
                    duration: 5000,
                    isClosable: true,
                });
            }*/

        });
    }


    useEffect(() => {

        toast.closeAll();

        if (Object.keys(errors).length > 0) {

            const errorList = Object.values(errors).map((error, index) => (
                <li key={index}>{error}</li>
            ));

            // const errorMessage = Object.values(errors).join('\n');
            toast({
                title: 'Prosíme vyplňte povinné údaje',
                description: (
                    <Box as="ul" ml={4}>
                        {errorList}
                    </Box>
                ),
                status: 'error',
                duration: 5000,
                isClosable: true,
                position: "top"
            });
        }

    }, [errors]);

    const getTextByPaymentCode = (paymentCode) => {

        if(paymentCode == PAYMENT_CARD) {
            return "Budete přesměrováni na zabezpečenou stránku, kam uvedete údaje z platební karty a banka během pár minut platbu zrealizuje.";
        } else if(paymentCode == PAYMENT_BANK_TRANSFER){
            return "S podporou QR platby.";
        }  else if(paymentCode == PAYMENT_CODE){
            return "Aktivace předplatného kódem.";
        }
    }

    return (
        <>
            <Flex gap="4" mb={4} direction="column">
                <Alert
                    status='info'
                    variant='subtle'
                    flexDirection='column'
                    alignItems='center'
                    justifyContent='center'
                    textAlign='start'
                >
                    <Flex alignItems='center' direction="row">
                        <AlertIcon />
                        <Flex direction="column">
                            <AlertTitle>Upozornění pro stávající předplatitele</AlertTitle>
                            <AlertDescription>
                                <Text pr={"3"} as={'span'}>V únorovém (2025) vydání Vinařského obzoru obdržíte kód pro aktivaci svého předplatného v online verzi. Aktivací online přístupu získáte přístup i k archivu všech Vinařských obzorů od roku 2014.</Text>
                            </AlertDescription>
                        </Flex>
                    </Flex>
                </Alert>
            </Flex>

            <Form ref={formRef} method={"post"} onSubmit={(event) => handleSubmit(event)} >

                <Box bg={"white"} mt={"5"}  padding={"10"} mt={5} boxShadow={"md"} borderRadius={10}>
                    <PurchaseOptions formData={formData} onChangeFunction={handleRadioPriceChange}/>
                </Box>

                <Box bg={"white"} padding={"10"} mt={5} boxShadow={"md"} borderRadius={10}>
                    <chakra.h2 textAlign={'start'} fontSize={'4xl'} pb={5} fontWeight={'bold'}>
                        {"Zadejte své údaje pro účet"}
                        <Text fontSize={"sm"} colorScheme='gray' fontWeight={"normal"}>Na zadaný e-mail pošleme informaci ohledně doručení a zpracování objednávky.</Text>
                    </chakra.h2>

                    <FormControlEvo>
                        <EmailInputEvo defaultVal={formData.email} handleChange={handleChangeEmail} />
                        {/*<EmailInputEvo defaultVal={formData.email} handleChange={handleChange} />*/}
                    </FormControlEvo>

                    {showPassword &&  (<FormControlEvo>
                        <FormLabel>
                            {fieldNameAndLabels.password.label}
                        </FormLabel>
                        <Input defaultValue={formData.password}  value={formData.password} type={"password"} name={fieldNameAndLabels.password.name}  isInvalid={!!errors.password} onInput={handleChange} />
                        <FormControlEvo>
                            <FormHelperText>
                                <Link fontWeight={"semibold"} fontSize="md" href={ROUTE_PASSWORD_RESET} color="blue.500">
                                    {"Obnovení hesla"}
                                </Link>
                            </FormHelperText>
                        </FormControlEvo>
                    </FormControlEvo>)}

                    <FormControlEvo>
                        <FormLabelEvo mandatory={true}>{fieldNameAndLabels.telephone.label}</FormLabelEvo>
                        <Input  defaultValue={formData.telephone} type={"text"} name={fieldNamesAndLabels.telephone.name} onInput={handleChange} />
                        <Box as={"div"} fontSize={"sm"}>Pro případnou komunikaci ohledně doručení a zpracování objednávky.</Box>
                    </FormControlEvo>
                </Box>
                <Box bg={"white"} mt={"5"} padding={"10"} boxShadow={"md"} borderRadius={10}>
                    <chakra.h2 textAlign={'start'} fontSize={'4xl'} pb={10} fontWeight={'bold'}>
                        Fakturační údaje
                    </chakra.h2>
                    <FormControlEvo>
                        <FormLabelEvo mandatory={true}>{fieldNameAndLabels.name.label}</FormLabelEvo>
                        <Input  defaultValue={formData.name} type={"text"} name={fieldNamesAndLabels.name.name} onInput={handleChange} />
                    </FormControlEvo>

                    <FormControlEvo>
                        <FormLabelEvo mandatory={true}>{fieldNameAndLabels.surname.label}</FormLabelEvo>
                        <Input  defaultValue={formData.surname} type={"text"} name={fieldNamesAndLabels.surname.name} onInput={handleChange} />
                    </FormControlEvo>

                    <FormControlEvo>
                        {/*<Checkbox name={fieldNamesAndLabels.asCompany.name} onInput={(e) => setIsCompanyFieldsVisible(e.target.checked)}>*/}
                        <Checkbox name={fieldNamesAndLabels.asCompany.name} onInput={handleChange}>
                            {fieldNamesAndLabels.asCompany.label}
                        </Checkbox>
                    </FormControlEvo>


                    {isCompanyFieldsVisible && (<VStack spacing={4}>
                        <FormControlEvo>
                            <FormLabelEvo>{fieldNameAndLabels.companyName.label}</FormLabelEvo>
                            <Input  defaultValue={formData.companyName} type={"text"} name={fieldNamesAndLabels.companyName.name} onInput={handleChange} />
                        </FormControlEvo>

                        <FormControlEvo>
                            <FormLabelEvo>{fieldNameAndLabels.ico.label}</FormLabelEvo>
                            <Input  defaultValue={formData.ico} type={"text"} name={fieldNamesAndLabels.ico.name} onInput={handleChange} />
                        </FormControlEvo>


                        <FormControlEvo>
                            <FormLabelEvo>{fieldNameAndLabels.dic.label}</FormLabelEvo>
                            <Input  defaultValue={formData.dic} type={"text"} name={fieldNamesAndLabels.dic.name} onInput={handleChange} />
                        </FormControlEvo>
                    </VStack>)
                    }

                    <FormControlEvo>
                        <FormLabelEvo mandatory={true}>{fieldNameAndLabels.street.label}</FormLabelEvo>
                        <Input   defaultValue={formData.street} type={"text"} name={fieldNamesAndLabels.street.name} onInput={handleChange} />
                    </FormControlEvo>

                    <FormControlEvo>
                        <FormLabelEvo mandatory={true}>{fieldNameAndLabels.city.label}</FormLabelEvo>
                        <Input  defaultValue={formData.city} type={"text"} name={fieldNamesAndLabels.city.name} onInput={handleChange} />
                    </FormControlEvo>

                    <FormControlEvo>
                        <FormLabelEvo mandatory={true}>{fieldNameAndLabels.zipCode.label}</FormLabelEvo>
                        <Input   defaultValue={formData.zipCode} type={"text"} name={fieldNamesAndLabels.zipCode.name} onInput={handleChange} />
                    </FormControlEvo>

                    <FormControlEvo>
                        {/*<Checkbox name={fieldNamesAndLabels.deliveryDifferentAddress.name} onInput={(e) => setIsAddressDeliveryVisible(e.target.checked)}>*/}
                        <Checkbox name={fieldNamesAndLabels.deliveryDifferentAddress.name} onInput={handleChange}>
                            {fieldNamesAndLabels.deliveryDifferentAddress.label}
                        </Checkbox>
                    </FormControlEvo>

                    {isAddressDeliveryVisible && (<VStack spacing={4}>
                        <FormControlEvo>
                            <FormLabel>
                                Jméno a příjmení
                            </FormLabel>
                            <Input   defaultValue={formData.nameDelivery} type={"text"} name={'nameDelivery'} onInput={handleChange} />
                        </FormControlEvo>

                        <FormControlEvo>
                            <FormLabel>
                                Ulice
                            </FormLabel>
                            <Input defaultValue={formData.streetDelivery} type={"text"} name={'streetDelivery'} onInput={handleChange} />
                        </FormControlEvo>

                        <FormControlEvo>
                            <FormLabel>
                                Město
                            </FormLabel>
                            <Input defaultValue={formData.cityDelivery} type={"text"} name={'streetDelivery'} onInput={handleChange} />
                        </FormControlEvo>

                        <FormControlEvo>
                            <FormLabel>
                                PSČ
                            </FormLabel>
                            <Input defaultValue={formData.zipCodeDelivery}  type={"text"} name={'zipCodeDelivery'} onInput={handleChange} />
                        </FormControlEvo>
                    </VStack>)
                    }

                </Box>


                <Box bg={"white"} mt={"5"} padding={"10"} boxShadow={"md"} borderRadius={10}>
                    <chakra.h2 textAlign={'start'} fontSize={'4xl'} pb={10} fontWeight={'bold'}>
                        Zvolte si způsob platby
                    </chakra.h2>

                    <FormControlEvo>
                        {paymentOptions && (<RadioGroup mt="2%"  name={formData.paymentType} value={formData.paymentType} onChange={handleRadioPaymentChange} >
                            <Stack direction={'column'} alignItems={"start"} justifyContent={"start"}>


                                {Object.values(paymentOptions).map((value, index) => (
                                    <Radio value={value.code} w={"100%"}>
                                        <Stack alignItems={"center"} justifyContent={"start"} width={"100%"} direction={'row'}>
                                            <Option title={value.value} desc={getTextByPaymentCode(value.code)}/>
                                            {value.code == PAYMENT_CARD && (<Stack direction={"row"}>
                                                <Image
                                                    maxWidth={{ base: "76px"}}
                                                    rounded="md"
                                                    alt={'Login Image'}
                                                    objectFit={'contain'}
                                                    display={{ base: "none", md: "block" }}
                                                    src={
                                                        '/images/payment_mc.png'
                                                    }
                                                />
                                                <Image
                                                    maxWidth={{ base: "76px"}}
                                                    rounded="md"
                                                    alt={'Login Image'}
                                                    objectFit={'contain'}
                                                    display={{ base: "none", md: "block" }}
                                                    src={
                                                        '/images/payment_visa.png'
                                                    }
                                                />
                                            </Stack>)}
                                            {value.code == PAYMENT_BANK_TRANSFER && ( <Stack direction={"row"}>
                                                <Image
                                                    alignSelf={"end"}
                                                    maxWidth={{ base: "76px"}}
                                                    rounded="md"
                                                    alt={'Login Image'}
                                                    objectFit={'contain'}
                                                    display={{ base: "none", md: "block" }}
                                                    src={
                                                        '/images/bank_transfer.png'
                                                    }
                                                />
                                            </Stack>)}

                                        </Stack>
                                    </Radio>
                                ))}
                                {isCodeInputVisible && (<Input placeholder={"Zadajte kód"} defaultValue={""} type={"text"} name={fieldNamesAndLabels.subscriptionActivationCode.name} onInput={handleChange} />)}
                            </Stack>
                        </RadioGroup>)}
                    </FormControlEvo>
                </Box>
                <FormControlEvo>

                    <Text pb={3}>Kliknutím na tlačítko pro dokončení objednávky souhlasíte se
                        <Link target="_blank" color="blue.500"
                              textDecoration="underline"
                              size="sm" colorScheme='blue' as={"a"} href={"vop.pdf"}
                              px={1}
                        >
                            {"všeobecnými obchodními podmínkami"}
                        </Link>
                        a
                        <Link target="_blank" color="blue.500"
                              textDecoration="underline"
                              size="sm" colorScheme='blue' as={"a"} href={"poou.pdf"}
                              pl={1}
                        >
                            {"zásadami ochrany osobních údajů"}
                        </Link>.
                    </Text>
                    <Button colorScheme='pink' variant='solid' type={"submit"}>{"Objednat a zavázat se k platbě"}</Button>
                </FormControlEvo>
            </Form>
        </>
    )

}




const ExternalRedirect = ({ url }) => {
    window.location.href = url;
    return null;
};

const options = [
    { id: 1, desc: '1 lorem ipsum' },
    { id: 2, desc: 'Lorem, ipsum dolor.' },
    { id: 3, desc: 'Monthly Updates' },
]

const Option = ({title, desc}) => {
    return (
        <Box px={5} width="full">
            <Stack spacing={1} width={'100%'} direction={'column'}>
                <OptionRow title={title} desc={desc} typePlan="Free" options={options} />
            </Stack>
        </Box>
    )
}


interface PackageTierProps {
    title: string,
    desc: string,
    options: Array<{ id: number; desc: string }>,
    typePlan: string,
    checked?: boolean,
}

const OptionRow = ({ title, desc, options, typePlan, checked = false }: PackageTierProps) => {
    const colorTextLight = checked ? 'white' : 'purple.600'
    const bgColorLight = checked ? 'purple.400' : 'gray.300'

    const colorTextDark = checked ? 'white' : 'purple.500'
    const bgColorDark = checked ? 'purple.400' : 'gray.300'

    return (
        <Stack direction={{
            base: 'row',
            md: 'row'
        }}>
            <Stack
                p={3}
                py={3}
                justifyContent={{
                    base: 'flex-start',
                    md: 'space-around',
                }}
                direction={{
                    base: 'column',
                    md: 'column',
                }}
                gap={1}
                alignItems={{ md: 'start' }}>
                <Heading size={'md'}>{title}</Heading>
                {desc && <Stack>
                    <Text>{desc}</Text>
                </Stack>}
            </Stack>
        </Stack>
    )
}

const PurchaseOptions = ({formData, onChangeFunction}) => {



    const [subscriptionOptions, setSubscriptionOptions] = useState({});

    if( Object.keys(subscriptionOptions).length  == 0) {
        let dp = new SubscriptionOptionsDataProvider();
        dp.getData({}, {}).then((res) => {
            if (res && res.status === 'OK') {
                setSubscriptionOptions(res.data.values);
            }
        });
    }


    return <>
        <Stack direction='column'>
            {/*<FormControlEvo>*/}
            <RadioGroup mt="2%"  name={formData.subscriptionType} value={formData.subscriptionType} defaultValue={formData.subscriptionType} onChange={onChangeFunction} >

                {Object.values(subscriptionOptions).map((value, index) => (
                    <VStack align="stretch">
                        <Box
                            display="flex"
                            flexDirection={{ base: "column", md: "row" }}
                            w="100%"
                        >
                            <Radio
                                value={value.code}
                                display="flex"
                                alignItems="center" // To ensure alignment works within flex
                                w="100%"
                            ><Option title={value.value} desc={"Každý měsíc Vám zpřístupníme online verzi časopisu Vinařský obzor."} />
                            </Radio>
                            <Box
                                display={"flex"}
                                alignItems={"center"}
                                flexDirection={"column"}
                                w={{ base: "100%", md: 200 }}
                            >
                                <Box as="div" fontWeight={"bold"} fontSize={"xl"}>
                                    {PRICE_ONLINE_PHYSICAL_COPY}{" Kč / rok"}
                                </Box>
                                <Box as="div" fontSize={"sm"}>
                                    {swapDotForComma(PRICE_ONLINE_PHYSICAL_COPY - PRICE_ONLINE_PHYSICAL_COPY * 0.12).toString()}
                                    {" Kč bez DPH"}
                                </Box>
                                <Box
                                    px={2}
                                    fontSize={"sm"}
                                    as="div"
                                    whiteSpace="nowrap"
                                >
                                    {Math.ceil(PRICE_ONLINE_PHYSICAL_COPY / 12)} Kč / měsíčně
                                </Box>
                            </Box>
                        </Box>
                    </VStack>
                ))}
            </RadioGroup>
        </Stack>
    </>



    //
    // return <Stack direction='column'>
    //     {/*<FormControlEvo>*/}
    //     <RadioGroup mt="2%"  name={formData.subscriptionType} value={"3"} value={formData.subscriptionType} defaultValue={formData.subscriptionType} onChange={onChangeFunction} >
    //         <VStack align="stretch">
    //             <Radio display="flex" w="100%" value={'3'}>
    //                 <Option title={"Tištěné + Online vydání rok 2025"} desc={"Každý měsíc Vám zpřístupníme online verzi časopisu Vinařský obzor."}/>
    //                 <Box display={"flex"} flexDirection={"column"} w={150}>
    //                     <Box as="div" fontWeight={"bold"} fontSize={'xl'}>{PRICE_ONLINE_PHYSICAL_COPY}{" Kč / Rok"}</Box>
    //                     <Box px={2} as="div" whiteSpace="nowrap">{Math.ceil(PRICE_ONLINE_PHYSICAL_COPY / 12)} Kč / měsíčně</Box>
    //                 </Box>
    //             </Radio>
    //         </VStack>
    //     </RadioGroup>
    //     {/*</FormControlEvo>*/}
    // </Stack>

    /*<Radio value={value.code} w={"100%"}>
               <Stack alignItems={"center"} justifyContent={"start"} width={"100%"} direction={'row'}>
                <Option title={value.value} desc={getTextByPaymentCode(value.code)}/>
                   {value.code == PAYMENT_CARD && (<Stack direction={"row"}>
                   <Image
                       maxWidth={{ base: "76px"}}
                       rounded="md"
                       alt={'Login Image'}
                       objectFit={'contain'}
                       src={
                           '/images/payment_mc.png'
                       }
                   />
                   <Image
                       maxWidth={{ base: "76px"}}
                       rounded="md"
                       alt={'Login Image'}
                       objectFit={'contain'}
                       src={
                           '/images/payment_visa.png'
                       }
                   />
               </Stack>)}
               {value.code == PAYMENT_BANK_TRANSFER && ( <Stack direction={"row"}>
                   <Image
                       alignSelf={"end"}
                       maxWidth={{ base: "76px"}}
                       rounded="md"
                       alt={'Login Image'}
                       objectFit={'contain'}
                       src={
                           '/images/bank_transfer.png'
                       }
                   />
               </Stack>)}

               </Stack>
           </Radio>*/

}